import dayjs from "dayjs";

export function formatTimestamp(timestamp: string | Date): string {
  return dayjs(timestamp).format("L LT");
}
